import { render } from "./ReceiverMode.vue?vue&type=template&id=6ad76582"
import script from "./ReceiverMode.vue?vue&type=script&lang=js"
export * from "./ReceiverMode.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/scripts/view/review/ReceiverMode.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ad76582"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ad76582', __exports__)) {
    api.reload('6ad76582', __exports__)
  }
  
  module.hot.accept("./ReceiverMode.vue?vue&type=template&id=6ad76582", () => {
    api.rerender('6ad76582', render)
  })

}


export default __exports__